import { FC } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import { TableHead, TableRow, TableWrapper } from '@/components';

import styles from './equalTable.module.scss';
import { Simplify } from '../../../prismicio-types';

const headComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.headText}>{children}</p>,
};

type Props = {
  data: Simplify<Content.PolicyTableSliceEqualPrimary>;
};

export const EqualTable: FC<Props> = ({ data }) => {
  return (
    <TableWrapper>
      <TableHead className={styles.head}>
        {data.head.map((item, index) => (
          <PrismicRichText
            key={`${item.title[0]?.type}-${index}`}
            field={item.title}
            components={headComponents}
          />
        ))}
      </TableHead>
      <TableWrapper>
        {data.body.map((item, index) => {
          const hasDescription = 'description' in item;

          return (
            <TableRow
              key={`${item.title[0]?.type}-${index}`}
              className={styles.row}
            >
              <div className={styles.titleWrapper}>
                <PrismicRichText field={item.title} />
              </div>
              {hasDescription && <PrismicRichText field={item.description} />}
            </TableRow>
          );
        })}
      </TableWrapper>
    </TableWrapper>
  );
};
